import React from 'react';
import { useParams } from 'react-router-dom';
import './Page.css';

const AboutUs = () => {
  const { subpage } = useParams();

  if (subpage === 'mission-vision') {
    return (
      <div className="page-container">
        <div className="page-header">
          <h1>Mission and Vision</h1>
        </div>
        <div className="page-content">
          <div className="mission-vision-container">
            <div className="mission-section">
              <h2>MISSION</h2>
              <p>
                At Millennium Model School, our mission is to provide a nurturing and inclusive learning environment that empowers students to achieve their fullest potential. We are dedicated to fostering a passion for lifelong learning, cultivating critical thinking skills, and nurturing creativity. Through personalized education, a diverse curriculum, and a commitment to character development, we aim to shape responsible global citizens who contribute positively to society.
              </p>
            </div>
            <div className="vision-section">
              <h2>VISION</h2>
              <p>
                Our vision is to be a premier institution known for excellence in education and character development. We aspire to cultivate a community of learners who embrace challenges, demonstrate resilience, and strive for excellence in all aspects of their lives. By fostering a culture of collaboration, innovation, and continuous improvement, we aim to empower our students to become compassionate leaders who drive positive change in a rapidly evolving world.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (subpage === 'general-information') {
    return (
      <div className="page-container">
        <div className="page-header">
          <h1>General Information</h1>
        </div>
        <div className="page-content">
          <div className="info-table-container">
            <table className="info-table">
              <tbody>
                <tr>
                  <td className="info-label">School Name</td>
                  <td className="info-value">Millennium Model School</td>
                </tr>
                <tr>
                  <td className="info-label">DISE Code</td>
                  <td className="info-value">23110414101</td>
                </tr>
                <tr>
                  <td className="info-label">District</td>
                  <td className="info-value">Sagar, Madhya Pradesh</td>
                </tr>
                <tr>
                  <td className="info-label">Address</td>
                  <td className="info-value">Khajrod road, Mandi Bamora</td>
                </tr>
                <tr>
                  <td className="info-label">Email</td>
                  <td className="info-value">millenniummodel2000@gmail.com</td>
                </tr>
                <tr>
                  <td className="info-label">Phone No.</td>
                  <td className="info-value">9926336071, 8982352628</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  if (subpage === 'bank-details') {
    return (
      <div className="page-container">
        <div className="page-header">
          <h1>Bank Details</h1>
        </div>
        <div className="page-content">
          <div className="info-table-container">
            <table className="info-table">
              <tbody>
                <tr>
                  <td className="info-label">Bank Account Number</td>
                  <td className="info-value">3196422971</td>
                </tr>
                <tr>
                  <td className="info-label">IFSC Code</td>
                  <td className="info-value">CBIN0280740</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  const pageContent = {
    'principals-message': {
      title: "Principal's Message",
      content: "Content for Principal's Message will be added here."
    },
    'faculties': {
      title: 'Faculties',
      content: 'Content for Faculties will be added here.'
    }
  };

  const currentPage = pageContent[subpage] || {
    title: 'About Us',
    content: 'Please select a section from the About Us menu.'
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>{currentPage.title}</h1>
      </div>
      <div className="page-content">
        <p>{currentPage.content}</p>
      </div>
    </div>
  );
};

export default AboutUs;

